module.exports = __webpack_public_path__ + "img/sg.05ac5a15.svg";